import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="sync-inputs"
export default class extends Controller {
  static targets = ["input"];
  connect() {
    this.inputTargets.forEach((input) => {
      this.inputTargets.forEach((otherInput) => {
        if (!otherInput.value) {
          otherInput.value = input.value;
        }
      });
      input.addEventListener("change", () => {
        this.inputTargets.forEach((otherInput) => {
          otherInput.value = input.value;
        });
      });
    });
  }
}
